import { SET_SEARCH_CLAIM } from './types';

const initialState = {
  searchClaim: '',
};

export const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_CLAIM:
      return { ...state, searchClaim: action.payload };
    default:
      return state;
  }
};
